import React, { memo, useEffect, useState } from "react";
import FormsAttachment from "./subcomponents/FormsAttachment";
import AttachmentList from "../../components/Common/AttachmentsInteraction";
import DocViewer from "../../components/DocViwer";

import { Redirect, useLocation } from "react-router-dom";

import "./style.scss";
import { useSelector } from "react-redux";

function AttachmentsInteractionPage() {
  const location = useLocation();
  const { activeChat = null } = location.state || {};
  const [showFormAction, setShowFormAction] = useState(false)

  const { activeAttachment = null } =
    useSelector((state) => state.AttachmentsInteraction?.[activeChat]) || {};

  if (!activeChat) {
    return <Redirect to="/chats" />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (activeAttachment?.file_status !== "sent" && activeAttachment?.file_status !== "requested") {
      setShowFormAction(true)
    } else {
      setShowFormAction(false)
    }
  }, [activeAttachment,])

  return (
    <div className="container-attachments-page">
      <div className="attachments-interaction-page">
        <div className="attachments-preview">
          <div className="preview-area">
            <DocViewer activeAttachment={activeAttachment} />
          </div>
          {
            (showFormAction && (
              <div className="attachment-forms">
                <FormsAttachment activeChat={activeChat} />
              </div>
            ))
          }
        </div>
        <div className="attachments-list ">
          <AttachmentList activeChat={activeChat} />
        </div>
      </div>
    </div>
  );
}

export default memo(AttachmentsInteractionPage);